<template>
  <tr @click="navigateToDetails">
    <td class="multi_select" @click.stop><input :checked="isCardChecked" type="checkbox" @change.prevent="onMultiSelectChange"></td>
    <td class="engraved_id">{{ cardSummary.engravedId | engravedId }}</td>
    <td class="card_holder_details">{{ cardHolderDetails }}</td>
    <td class="combined_ascriptions">{{ combinedAscriptions }}</td>
    <td class="card_valid_until">{{ cardSummary.validUntil | dateFormatOrDefault('-') }}</td>
  </tr>
</template>

<script>
import engravedId from '../../filters/engraved-id'
import {dateFormatOrDefault} from '../../filters/date-format'

export default {
  name: 'OrderTerminateCardListItem',
  filters: {
    dateFormatOrDefault,
    engravedId
  },
  props: {
    cardSummary: {
      type: Object,
      required: true
    },
    isCardChecked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardHolderDetails () {
      if (this.cardSummary.customer) {
        let cardHolderDetails = this.cardSummary.customer.firstName

        if (this.cardSummary.customer.surnamePrefix) {
          cardHolderDetails += ' ' + this.cardSummary.customer.surnamePrefix
        }

        cardHolderDetails += ' ' + this.cardSummary.customer.surname

        return cardHolderDetails
      }

      return ''
    },
    combinedAscriptions () {
      return [this.cardSummary.ascription, this.cardSummary.ascription1, this.cardSummary.ascription2].join(' ')
    }
  },
  methods: {
    navigateToDetails () {
      this.$router.push(
        {
          name: 'card-details',
          params: {
            cardId: this.cardSummary.cardId
          }
        })
    },
    onMultiSelectChange (e) {
      this.$emit('rowCheckChange', {cardSummary: this.cardSummary, newIsCheckboxChecked: e.target.checked})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/orderTerminateCard/OrderTerminateCardListItem.vue